export type SupportLinkName =
  | 'support'
  | 'blog'
  | 'anesthesiaInfo'
  | 'termsOfUse'
  | 'privacyPolicy'
  | 'privacyPractices'
  | 'telehealthPolicy'
  | 'termsSuffix';

type SupportLinksMap = {
  [f in 'US' | 'FR']: {
    [l in SupportLinkName]?: string;
  };
};

export const supportLinks: SupportLinksMap = {
  US: {
    support: 'https://www.hoopcare.com/us/support',
    blog: 'https://www.hoopcare.com/us/patients/blog',
    anesthesiaInfo: 'https://www.hoopcare.com/us/patients/information/home',
    termsOfUse: 'https://www.hoopcare.com/us/legal/terms-of-use',
    privacyPolicy: 'https://www.hoopcare.com/us/legal/privacy-policy',
    privacyPractices: 'https://www.hoopcare.com/us/legal/privacy-practices',
    telehealthPolicy: 'https://www.hoopcare.com/us/legal/telehealth-policy',
    termsSuffix: 'patient-app.auth.t&c.suffix.us'
  },
  FR: {
    support: 'https://www.hoopcare.com/fr/support',
    blog: 'https://www.hoopcare.com/fr/patient/blog',
    anesthesiaInfo: 'https://www.hoopcare.com/fr/patient/information',
    termsOfUse: 'https://www.hoopcare.com/fr/legal/mentions-legales-cgu',
    privacyPolicy:
      'https://www.hoopcare.com/fr/legal/politique-de-confidentialite'
  }
};
